import _defineProperty from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { createPayment, confirmPayment } from './StripePaymentForm.config.js';
import authStatusConstants from '../../constants/authStatusConstants.js';
import errorCodeConstants from '../../constants/errorCodeConstants.js';
import paymentMethodTypes from '../../constants/paymentMethodTypeConstants.js';
import paymentStatus from '../../constants/paymentStatusConstants.js';
import billingAddressHasRequiredFields from '../../utils/billingAddressHasRequiredFields.js';
import mapBillingDetailsToStripe from '../../utils/mapBillingDetailsToStripe.js';
import { checkIsExpressCheckout, checkIsCardCheckout } from '../../utils/paymentMethod.js';
import StripeExpressCheckoutElement from './stripe-express-checkout-element/StripeExpressCheckoutElement.js';
import StripePaymentElement from './stripe-payment-element/StripePaymentElement.js';
var StripePaymentForm = function StripePaymentForm(_ref) {
  var amount = _ref.amount,
    afterFormContent = _ref.afterFormContent,
    beforeButtonContent = _ref.beforeButtonContent,
    billing_details = _ref.billingDetails,
    classNames = _ref.classNames,
    isStubbed = _ref.isStubbed,
    loadingIndicator = _ref.loadingIndicator,
    metadata = _ref.metadata,
    _ref$onReadyToRenderH = _ref.onReadyToRenderHandler,
    onReadyToRenderHandler = _ref$onReadyToRenderH === void 0 ? function () {} : _ref$onReadyToRenderH,
    paymentHandlers = _ref.paymentHandlers,
    _ref$paymentMethodTyp = _ref.paymentMethodType,
    paymentMethodType = _ref$paymentMethodTyp === void 0 ? paymentMethodTypes.CARD : _ref$paymentMethodTyp,
    renderPaymentButton = _ref.renderPaymentButton;
  var stripe = useStripe();
  var elements = useElements();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isProcessing = _useState2[0],
    setIsProcessing = _useState2[1];
  var _useMemo = useMemo(function () {
      return {
        isCardCheckout: checkIsCardCheckout(paymentMethodType),
        isExpressCheckout: checkIsExpressCheckout(paymentMethodType)
      };
    }, [paymentMethodType]),
    isCardCheckout = _useMemo.isCardCheckout,
    isExpressCheckout = _useMemo.isExpressCheckout;
  var handleError = function handleError(error) {
    var _paymentHandlers$onEr;
    if (error && Object.keys(error).length > 0) {
      setIsProcessing(false);
    }
    paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onEr = paymentHandlers.onError) === null || _paymentHandlers$onEr === void 0 || _paymentHandlers$onEr.call(paymentHandlers, error);
  };
  var checkHasRequiredFields = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var billingDetails;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            billingDetails = _ref2.billingDetails;
            if (billingAddressHasRequiredFields(billingDetails)) {
              _context.next = 5;
              break;
            }
            console.warn('debug: checkHasRequiredFields() error; billingDetails', billingDetails);
            handleError({
              code: errorCodeConstants.STRIPE_BILLING_DETAILS_INCOMPLETE
            });
            return _context.abrupt("return", false);
          case 5:
            return _context.abrupt("return", true);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function checkHasRequiredFields(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var toggleProcessing = function toggleProcessing(processing) {
    setIsProcessing(processing);
    if (processing) {
      handleError({});
    }
  };
  var submitElements = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref4) {
      var elements, _yield$elements$submi, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            elements = _ref4.elements;
            _context2.next = 3;
            return elements.submit();
          case 3:
            _yield$elements$submi = _context2.sent;
            error = _yield$elements$submi.error;
            if (!error) {
              _context2.next = 9;
              break;
            }
            console.warn('debug: submitElements() error; error', error);
            handleError(error);
            return _context2.abrupt("return", false);
          case 9:
            return _context2.abrupt("return", true);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function submitElements(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var createPaymentMethod = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref6) {
      var billing_details, elements, stripe, _yield$stripe$createP, createPaymentMethodError, paymentMethod;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            billing_details = _ref6.billingDetails, elements = _ref6.elements, stripe = _ref6.stripe;
            _context3.next = 3;
            return stripe.createPaymentMethod({
              elements: elements,
              params: {
                billing_details: billing_details,
                metadata: metadata
              }
            });
          case 3:
            _yield$stripe$createP = _context3.sent;
            createPaymentMethodError = _yield$stripe$createP.error;
            paymentMethod = _yield$stripe$createP.paymentMethod;
            if (!createPaymentMethodError) {
              _context3.next = 10;
              break;
            }
            console.warn('debug: createPaymentMethod() error; createPaymentMethodError', createPaymentMethodError);
            handleError(_objectSpread(_objectSpread({}, createPaymentMethodError), {}, {
              code: errorCodeConstants.STRIPE_DEFAULT_ERROR
            }));
            return _context3.abrupt("return", null);
          case 10:
            return _context3.abrupt("return", paymentMethod);
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function createPaymentMethod(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  var processPayment = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref8) {
      var billingDetails, paymentMethodId, stripe, stubbedStatus, stubbedAuthStatus, identifier, _typeMap$paymentMetho, typeMap, prefix, _yield$createPayment, clientSecret, jlppr, status, _yield$stripe$handleN, handleNextActionError, response, _paymentHandlers$onPa, _paymentHandlers$onPa2;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            billingDetails = _ref8.billingDetails, paymentMethodId = _ref8.paymentMethodId, stripe = _ref8.stripe, stubbedStatus = _ref8.stubbedStatus, stubbedAuthStatus = _ref8.stubbedAuthStatus;
            identifier = stubbedStatus !== null && stubbedStatus !== void 0 ? stubbedStatus : paymentMethodId;
            if (identifier) {
              _context4.next = 5;
              break;
            }
            console.warn('No payment method or stubbed status provided.');
            return _context4.abrupt("return");
          case 5:
            if (isStubbed) {
              typeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, paymentMethodTypes.APPLE_PAY, 'APPLE_PAY'), paymentMethodTypes.APPLE_PAY_EXPRESS, 'APPLE_PAY'), paymentMethodTypes.GOOGLE_PAY, 'GOOGLE_PAY'), paymentMethodTypes.CARD, 'CARD');
              prefix = (_typeMap$paymentMetho = typeMap[paymentMethodType]) !== null && _typeMap$paymentMetho !== void 0 ? _typeMap$paymentMetho : paymentMethodTypes.CARD;
              identifier = "".concat(prefix, ":").concat(identifier);
            }
            _context4.prev = 6;
            _context4.next = 9;
            return createPayment(identifier);
          case 9:
            _yield$createPayment = _context4.sent;
            clientSecret = _yield$createPayment.clientSecret;
            jlppr = _yield$createPayment.jlppr;
            status = _yield$createPayment.status;
            if (!(status === paymentStatus.DECLINED)) {
              _context4.next = 17;
              break;
            }
            console.warn('debug: processPayment() error; paymentStatus.DECLINED');
            handleError({
              code: errorCodeConstants.STRIPE_PAYMENT_DECLINED
            });
            return _context4.abrupt("return");
          case 17:
            if (!(status === paymentStatus.CREATED)) {
              _context4.next = 39;
              break;
            }
            if (!(stubbedAuthStatus === authStatusConstants.FAIL || stubbedAuthStatus === authStatusConstants.CANCELLED)) {
              _context4.next = 21;
              break;
            }
            handleError({
              code: errorCodeConstants.PAYMENT_INTENT_AUTHENTICATION_FAILURE,
              type: 'invalid_request_error'
            });
            return _context4.abrupt("return");
          case 21:
            if (!(!stubbedStatus && stripe && clientSecret)) {
              _context4.next = 30;
              break;
            }
            _context4.next = 24;
            return stripe.handleNextAction({
              clientSecret: clientSecret
            });
          case 24:
            _yield$stripe$handleN = _context4.sent;
            handleNextActionError = _yield$stripe$handleN.error;
            if (!handleNextActionError) {
              _context4.next = 30;
              break;
            }
            console.warn('debug: processPayment() error; paymentStatus.CREATED: handleNextActionError', handleNextActionError);
            handleError(handleNextActionError);
            return _context4.abrupt("return");
          case 30:
            _context4.next = 32;
            return confirmPayment(jlppr);
          case 32:
            response = _context4.sent;
            if (!response) {
              _context4.next = 39;
              break;
            }
            if (paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onPaymentSuccess) {
              _context4.next = 37;
              break;
            }
            console.warn('No payment success handler provided.');
            return _context4.abrupt("return");
          case 37:
            _context4.next = 39;
            return paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onPa = paymentHandlers.onPaymentSuccess) === null || _paymentHandlers$onPa === void 0 ? void 0 : _paymentHandlers$onPa.call(paymentHandlers, {
              billingDetails: billingDetails
            });
          case 39:
            if (!(status === paymentStatus.AUTHORISED)) {
              _context4.next = 45;
              break;
            }
            if (paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onPaymentSuccess) {
              _context4.next = 43;
              break;
            }
            console.warn('No payment success handler provided.');
            return _context4.abrupt("return");
          case 43:
            _context4.next = 45;
            return paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onPa2 = paymentHandlers.onPaymentSuccess) === null || _paymentHandlers$onPa2 === void 0 ? void 0 : _paymentHandlers$onPa2.call(paymentHandlers, {
              billingDetails: billingDetails
            });
          case 45:
            _context4.next = 50;
            break;
          case 47:
            _context4.prev = 47;
            _context4.t0 = _context4["catch"](6);
            handleError(_objectSpread(_objectSpread({}, _context4.t0), {}, {
              code: errorCodeConstants.STRIPE_DEFAULT_ERROR
            }));
          case 50:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[6, 47]]);
    }));
    return function processPayment(_x4) {
      return _ref9.apply(this, arguments);
    };
  }();
  var onSubmitHandler = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref0) {
      var _normalisedBillingDet, _paymentHandlers$onBu;
      var billingDetails, selectedShippingOptionIdentifier, shippingAddress, stubbedStatus, stubbedAuthStatus, normalisedBillingDetails, normalisedShippingAddress, paymentMethod;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            billingDetails = _ref0.billingDetails, selectedShippingOptionIdentifier = _ref0.selectedShippingOptionIdentifier, shippingAddress = _ref0.shippingAddress, stubbedStatus = _ref0.stubbedStatus, stubbedAuthStatus = _ref0.stubbedAuthStatus;
            if (!isProcessing) {
              _context5.next = 3;
              break;
            }
            return _context5.abrupt("return");
          case 3:
            normalisedBillingDetails = mapBillingDetailsToStripe(billingDetails);
            normalisedShippingAddress = _objectSpread(_objectSpread({}, shippingAddress), {}, {
              phone: (_normalisedBillingDet = normalisedBillingDetails === null || normalisedBillingDetails === void 0 ? void 0 : normalisedBillingDetails.phone) !== null && _normalisedBillingDet !== void 0 ? _normalisedBillingDet : ''
            });
            toggleProcessing(true);
            if (!(!isStubbed && (!stripe || !elements))) {
              _context5.next = 9;
              break;
            }
            handleError({
              code: errorCodeConstants.STRIPE_NOT_LOADED
            });
            return _context5.abrupt("return");
          case 9:
            _context5.next = 11;
            return paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onBu = paymentHandlers.onButtonClick) === null || _paymentHandlers$onBu === void 0 ? void 0 : _paymentHandlers$onBu.call(paymentHandlers, {
              selectedShippingOptionIdentifier: selectedShippingOptionIdentifier,
              shippingAddress: normalisedShippingAddress
            });
          case 11:
            if (_context5.sent) {
              _context5.next = 14;
              break;
            }
            toggleProcessing(false);
            return _context5.abrupt("return");
          case 14:
            _context5.prev = 14;
            _context5.t0 = !isStubbed;
            if (!_context5.t0) {
              _context5.next = 20;
              break;
            }
            _context5.next = 19;
            return submitElements({
              elements: elements
            });
          case 19:
            _context5.t0 = !_context5.sent;
          case 20:
            if (!_context5.t0) {
              _context5.next = 23;
              break;
            }
            console.warn('debug: onSubmitHandler() error; return 5');
            return _context5.abrupt("return");
          case 23:
            _context5.next = 25;
            return checkHasRequiredFields({
              billingDetails: normalisedBillingDetails
            });
          case 25:
            if (_context5.sent) {
              _context5.next = 28;
              break;
            }
            console.warn('debug: onSubmitHandler() error; return 6', normalisedBillingDetails);
            return _context5.abrupt("return");
          case 28:
            if (!isStubbed) {
              _context5.next = 32;
              break;
            }
            _context5.next = 31;
            return processPayment({
              billingDetails: normalisedBillingDetails,
              stubbedStatus: stubbedStatus,
              stubbedAuthStatus: stubbedAuthStatus
            });
          case 31:
            return _context5.abrupt("return");
          case 32:
            _context5.next = 34;
            return createPaymentMethod({
              billingDetails: normalisedBillingDetails,
              elements: elements,
              stripe: stripe
            });
          case 34:
            paymentMethod = _context5.sent;
            if (paymentMethod) {
              _context5.next = 38;
              break;
            }
            console.warn('debug: onSubmitHandler() error; return 7');
            return _context5.abrupt("return");
          case 38:
            _context5.next = 40;
            return processPayment({
              billingDetails: normalisedBillingDetails,
              paymentMethodId: paymentMethod.id,
              stripe: stripe
            });
          case 40:
            _context5.next = 46;
            break;
          case 42:
            _context5.prev = 42;
            _context5.t1 = _context5["catch"](14);
            console.warn('debug: onSubmitHandler() error; return 9');
            handleError(_objectSpread(_objectSpread({}, _context5.t1), {}, {
              code: errorCodeConstants.STRIPE_DEFAULT_ERROR
            }));
          case 46:
            _context5.prev = 46;
            toggleProcessing(false);
            return _context5.finish(46);
          case 49:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[14, 42, 46, 49]]);
    }));
    return function onSubmitHandler(_x5) {
      return _ref1.apply(this, arguments);
    };
  }();
  return jsxs("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.container,
    children: [isExpressCheckout && jsx(StripeExpressCheckoutElement, {
      amount: amount,
      billingDetails: billing_details,
      classNames: classNames,
      elements: elements,
      isProcessing: isProcessing,
      isStubbed: isStubbed,
      loadingIndicator: loadingIndicator,
      onReadyToRenderHandler: onReadyToRenderHandler,
      onSubmitHandler: onSubmitHandler,
      paymentHandlers: paymentHandlers,
      paymentMethodType: paymentMethodType
    }), isCardCheckout && jsx(StripePaymentElement, {
      amount: amount,
      beforeButtonContent: beforeButtonContent,
      billingDetails: billing_details,
      classNames: classNames,
      isDisabled: !stripe || isProcessing,
      isStubbed: isStubbed,
      onReadyToRenderHandler: onReadyToRenderHandler,
      onSubmitHandler: onSubmitHandler,
      paymentHandlers: paymentHandlers,
      paymentMethodType: paymentMethodType,
      renderPaymentButton: renderPaymentButton
    }), jsx("div", {
      className: classNames === null || classNames === void 0 ? void 0 : classNames.afterFormContent,
      children: afterFormContent
    })]
  });
};
export { StripePaymentForm as default };